import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=4b38c37f&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"
import style0 from "./alarm.vue?vue&type=style&index=0&id=4b38c37f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38c37f",
  null
  
)

export default component.exports